/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import UrlParser from 'url-parse';
import PropTypes from 'prop-types';
import each from 'lodash/each';
import isEqual from 'lodash/isEqual';
import apiDecorator from 'api/api-decorator';
import localStorage from 'helpers/local-storage';
import marketStatPush, { marketStatEvents } from 'subsys/market-stat';

import PortmoneDriver from './drivers/portmone';
import DomikDriver from './drivers/domik';

const drivers = {
  portmone: PortmoneDriver,
  //domik: DomikDriver
};

export const consts = {
  STATUS_CHOOSE: 'sChoose',
  STATUS_REQUEST: 'sReq',
  STATUS_PAY: 'sPay',
  STATUS_WAIT: 'sWait',
  STATUS_PAYED: 'sPayed',
  STATUS_REJECTED: 'sRejected',
};

@apiDecorator
export default class Container extends Component {
  static propTypes = {
    // Order ID. If set - payment status will be request from
    // backend and we wait for order will be payed
    orderId: PropTypes.string,//eslint-disable-line
    // COmponent, that renders order block. See abstract-order-block.js for details
    orderBlock: PropTypes.func,
    // Advanced props for order block
    orderBlockProps: PropTypes.shape({}),
    // Load products by names (names constants is in products.js)
    productNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    // Promocode for order
    promocode: PropTypes.string,
    // Products, that will be selected by default
    defaultProducts: PropTypes.arrayOf(PropTypes.string),//eslint-disable-line
    itemIds: PropTypes.arrayOf(PropTypes.any),
    // URL, that redirects, when payment is completed
    // If empty - current URL will be used, and order_id query param will be added
    // URL must be relative and without query string,
    // order_id and status (success or error) will be added
    // automatically by this component
    payedUrl: PropTypes.string,
    // Advanced query params for wayback url
    payedUrlQuery: PropTypes.shape({}),
    marketstatEvent: PropTypes.string,
    // If set - advanced data will be stored in local storage
    saveAdvDataKey: PropTypes.string,
    // Do not reset products/selected products when update item ids and others.
    // This behavior needed for some cases, such as payment after form submit
    keepState: PropTypes.bool,
    // Use Domik's wallet, if it possible (balance is more than amount)
    useInternalWalletIfPossible: PropTypes.bool
  };

  static defaultProps = {
    useInternalWalletIfPossible: false
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.state = {
      ...this._getDefaultState(props),
      driverConfig: null,
      products: null,
      internalBalance: null
    };
  }

  componentDidMount() {
    this.loadProducts();
    this._requestInternalBalance();
    this._requestOrderStatusIfNeeded();
  }

  componentDidUpdate(prevProps) {
    if (this.props.keepState) return;
    if (
      isEqual(prevProps.itemIds, this.props.itemIds) &&
      isEqual(prevProps.orderId, this.props.orderId) &&
      isEqual(prevProps.productNames, this.props.productNames)
    ) return;
    this.setState(this._getDefaultState(this.props), () => {
      this.loadProducts();
      this._requestInternalBalance();
    });
  }

  _getAdvDataIfNeeded() {
    const { saveAdvDataKey } = this.props;
    if (saveAdvDataKey) {
      const advData = localStorage.get(`billOrders-${saveAdvDataKey}`);
      return advData || {};
    }
    return {};
  }

  _getDefaultState(props) {
    const driverCheck = Object.keys(drivers);
    return {
      driver: driverCheck.length === 1 ? driverCheck[0] : null,
      status: props.orderId ? consts.STATUS_WAIT : consts.STATUS_CHOOSE,
      orderId: props.orderId || null,
      orderParams: null,
      // Order data, that returned by check-status method
      orderData: null,
      waybackUrl: null,
      selectedProducts: props.defaultProducts || [],
      advData: this._getAdvDataIfNeeded(),
      promocode: props.promocode || null,
      amount: 0,
      internalBalance: 0
    };
  }

  _requestAmount = () => {
    const { selectedProducts, promocode } = this.state;
    const { itemIds } = this.props;
    this.api.get('/billing/amount', {
      queryString: { json: JSON.stringify({ selectedProducts, itemIds, promocode }) }
    }).then(resp => this.setState({ amount: resp.amount }));
    return null;
  }

  _requestInternalBalance = () => {
    this.api.get('/billing/balance', {})
      .then(resp => this.setState({ internalBalance: resp.balance }));
  }

  _buildProductsIdx = (products) => {
    const idx = {};
    const nDefs = [];
    each(products, (val) => {
      idx[val.sys_name] = val;
      if (val.default_on) {
        nDefs.push(val.sys_name);
      }
    });
    this.setState({
      amount: 0,
      products: idx,
      selectedProducts: [...this.state.selectedProducts, ...nDefs]
    }, this._requestAmount);
  };

  _buildPaymentDescription() {
    const { selectedProducts, products } = this.state;
    const descr = [];
    each(selectedProducts, prod => descr.push(products[prod].name));
    return descr.join(', ');
  }

  _requestOrderStatusIfNeeded = () => {
    const { orderId, status } = this.state;
    if (!orderId || status !== consts.STATUS_WAIT) return null;
    this.api.get(`/billing/order-status/${orderId}`)
      .then((orderData) => {
        if (orderData.status === 'wait_for_pay') {
          setTimeout(this._requestOrderStatusIfNeeded, 2000);
          return;
        }
        let nStatus = consts.STATUS_WAIT;
        switch (orderData.status) {
          case 'payed':
            nStatus = consts.STATUS_PAYED;
            break;
          case 'rejected':
            nStatus = consts.STATUS_REJECTED;
            break;
          default:
            break;
        }
        this.setState({ status: nStatus, orderData });
        this._requestInternalBalance();
      });
  };

  /*
  _calcAmount() {
    let amount = 0;
    const { selectedProducts, products } = this.state;
    const { itemIds } = this.props;
    each(selectedProducts, prod => amount += parseFloat(products[prod].price));
    if (itemIds.length && itemIds.length > 1) {
      amount *= itemIds.length;
    }
    return amount;
  }
   */

  loadProducts() {
    const { productNames } = this.props;
    this.api.get('/billing/products', { queryString: { names: JSON.stringify(productNames) } })
      .then(this._buildProductsIdx);
  }

  handlePay = () => {
    const { marketstatEvent } = this.props;//eslint-disable-line
    if (!marketstatEvent) {
      this.handlePayWrp();
      return;
    }

    marketStatPush(
      marketStatEvents.successError,
      marketstatEvent,
      'success'
    ).then(this.handlePayWrp);
  };

  handlePayWrp = () => {
    const { driver, selectedProducts, advData, promocode } = this.state;
    const { itemIds } = this.props;

    if (!driver) {
      console.warn('Driver not selected');
      return;
    }

    this.setState({
      status: consts.STATUS_REQUEST,
      driverConfig: null,
      orderParams: null,
      orderData: null,
      waybackUrl: null
    });

    const project = window.__PROJECT__;
    const reqCfg = this.api.get(`/billing/config/${driver}`);
    const reqOrd = this.api.post('/billing/create-order', { postData: {
      json: JSON.stringify({
        project,
        driver,
        item_ids: itemIds,
        product_ids: selectedProducts,
        promocode,
        adv_data: advData
      })
    }});

    Promise.all([reqCfg, reqOrd]).then(([driverConfig, orderParams]) => {
      const waybackUrl = new UrlParser(this.props.payedUrl || window.location.href, true);
      waybackUrl.set('query', {
        ...waybackUrl.query,
        ...this.props.payedUrlQuery,
        order_id: orderParams.hash
      });
      this.setState({
        status: orderParams.amount === 0 ? consts.STATUS_WAIT : consts.STATUS_PAY,
        driverConfig,
        orderParams,
        orderData: null,
        waybackUrl: waybackUrl.toString(),
        orderId: orderParams.hash
      });
      // If order amount is zero - go to wayback url
      if (orderParams.amount === 0) {
        window.location.href = waybackUrl;
      }
    });
  };

  handleSelectProduct = (productName, active) => {
    const selected = this.state.selectedProducts;
    const exists = selected.indexOf(productName);
    if (exists > -1 && !active) {
      selected.splice(exists, 1);
    }
    if (exists === -1 && active) {
      selected.push(productName);
    }
    this.setState({
      selectedProducts: selected
    }, this._requestAmount);
  };

  handleSetProducts = (products = []) => {
    this.setState({ selectedProducts: products  }, this._requestAmount);
  };

  handlePayRequestSent = () => {
    this.setState({
      status: consts.STATUS_WAIT,
      driverConfig: null,
      orderParams: null
    }, () => this._requestOrderStatusIfNeeded());
  };

  handleChangeAdvData = (key, value, noLocalStorage) => {
    const { saveAdvDataKey } = this.props;
    const newData = {
      ...this.state.advData,
      [key]: value
    };

    if (saveAdvDataKey && !noLocalStorage) {
      localStorage.put(`billOrders-${saveAdvDataKey}`, newData);
    }
    return new Promise((accept) => {
      this.setState({ advData: newData }, accept);
    })
  };

  render() {
    const {
      products,
      status,
      driverConfig,
      orderParams,
      driver,
      waybackUrl,
      selectedProducts,
      orderData,
      advData,
      amount,
      internalBalance
    } = this.state;
    const { orderBlockProps, useInternalWalletIfPossible, orderBlock: OrderBlock } = this.props;

    if (!products) return null;

    const useDomikDriver = (useInternalWalletIfPossible && internalBalance >= amount);
    const DriverRunner = useDomikDriver ? DomikDriver : drivers[driver];

    return (
      <>
        {status === consts.STATUS_PAY &&
          <DriverRunner
            config={driverConfig}
            order={orderParams}
            payRequestSent={this.handlePayRequestSent}
            waybackUrl={waybackUrl}
            description={this._buildPaymentDescription()}
          />
        }
        <OrderBlock
          status={status}
          products={products}
          selectedProducts={selectedProducts}
          handleOrder={this.handlePay}
          handleSelectProduct={this.handleSelectProduct}
          handleSetProducts={this.handleSetProducts}
          handleChangeAdvData={this.handleChangeAdvData}
          orderData={orderData}
          advData={advData}
          amount={amount}
          internalBalance={internalBalance}
          otherProps={orderBlockProps}
        />
      </>
    );
  }
}
